import { render, staticRenderFns } from "./wxpayfinished.vue?vue&type=template&id=5ea52fa6&scoped=true&"
import script from "./wxpayfinished.vue?vue&type=script&lang=js&"
export * from "./wxpayfinished.vue?vue&type=script&lang=js&"
import style0 from "./wxpayfinished.vue?vue&type=style&index=0&id=5ea52fa6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ea52fa6",
  null
  
)

export default component.exports